module.exports = __webpack_public_path__ + "assets/instagram-footer-1b60eb.svg";